import { useBandshopConfig } from 'context/BandshopConfigContex';
import { memo } from 'react';
import { StyleSheet, View } from 'react-native';
import { calcSizeForDevice } from 'utils/index';
import { Platform } from 'utils/platform';

import LivePlayerOrHeroSelector from 'components/LivePlayer';
import SearchProgram from 'components/Section/SearchProgram';
import SearchWatchingList from 'components/Section/SearchWatchingList';
import { SectionFavorite } from 'components/Section/SectionFavorite';
import SectionRanking from 'components/Section/SectionRanking';
import SectionSuggestion from 'components/Section/SectionSuggestion';
import SectionVideo from 'components/Section/SectionVideo';
import AccordionBandshop from 'components/Section/bandshop/AccordionBandshop';

export type DynamicListItemProps = {
  onLoaded?: () => void;
  waitToRender?: boolean;
  requestTVFocus?: boolean;
};

const DynamicListItem: React.FC<CmsHomeModule & DynamicListItemProps> = (props) => {
  // paddingX convertido para um valor fixo baseado em calcSizeForDevice, para manter compatibilidade e visual
  const paddingX = calcSizeForDevice(24); // Ajuste conforme necessário para manter o visual

  const bandshopConfig = useBandshopConfig();
  const allOffersDisabled = bandshopConfig?.offersAvailabilitySettings?.areAllOffersDisabled;
  const genericCollectionId = bandshopConfig?.bandshopOffers?.collectionId;

  switch (props._name) {
    case 'section':
      return (
        <View style={[styles.sectionWrapper, { paddingHorizontal: paddingX }]}>
          <SearchProgram {...props} />
        </View>
      );

    case 'sectionWatchingList':
      return (
        <View style={[styles.sectionWrapper, { paddingHorizontal: paddingX }]}>
          <SearchWatchingList {...props} _name="section" />
        </View>
      );

    case 'player':
      return <SectionVideo {...props} />;

    case 'hero':
      return <LivePlayerOrHeroSelector {...props} />;

    case 'sectionMyList':
      return (
        <View style={[styles.sectionWrapper, { paddingHorizontal: paddingX }]}>
          <SectionFavorite {...props} horizontal />
        </View>
      );

    case 'sectionRanking':
      return <SectionRanking {...props} />;

    case 'sectionSuggestion':
      return (
        <View style={[styles.sectionWrapper, { paddingHorizontal: paddingX }]}>
          <SectionSuggestion {...props} />
        </View>
      );
    case 'sectionBandshop': {
      const { isDisabled, collectionId } = props as any;
      const vtexId = collectionId ? collectionId : genericCollectionId;

      if (allOffersDisabled || isDisabled || Platform.isTV || !vtexId) {
        setTimeout(() => props?.onLoaded?.(), 0);
        return null;
      }

      return (
        <View style={{ paddingHorizontal: paddingX }}>
          <AccordionBandshop collectionId={vtexId} />
        </View>
      );
    }

    default:
      setTimeout(() => (props as any)?.onLoaded?.(), 0);
      return null;
  }
};

const styles = StyleSheet.create({
  sectionWrapper: {
    // paddingHorizontal é aplicado dinamicamente
  },
});

export default memo(DynamicListItem);
